import { EapSettingsFormProtocolModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/components/eap-settings-form-protocol/eap-settings-form-protocol.model';
import { EapSettingsCreateModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.model';

export const initialEapProtocolSettingsFormValues: Omit<EapSettingsFormProtocolModel, 'eapType'> = {
    username: '',
    caCertificateFilename: '',
    clientCertificateFilename: '',
    clientPrivateKeyFilename: '',
    password: '',
    confirmPassword: '',
    anonymousUser: '',
    caCertificate: null,
    clientCertificate: null,
    clientPrivateKey: null,
    assignedDeviceCount: 0,
};

export const initialEapSettingsCreateFormModel: EapSettingsCreateModel = {
    id: '',
    name: '',
    ssid: '',
    cipherType: 'AES',
    eapType: 'PEAP',
    ...initialEapProtocolSettingsFormValues,
};
